import React from "react";
import styled from "styled-components";
import AnimateOnScroll from "../../components/AnimateOnScroll";
import theme from "../../theme";
import { Inner, SubtitleSection } from "../../components/commonWidgets";
import HighlightTitle from "../../components/HighlightTitle";
import { FiClock, FiTrendingUp, FiCpu } from "react-icons/fi";
// Replace this path with the final path of your portrait image in /public or /assets
import portrait from "../../assets/images/portrait_me2.png";

const Section = styled.section`
  /*background: var(--my-color3);*/
  padding: 3rem 1rem;
  color: white;
  display: flex;
  justify-content: center;
`;

const Container = styled(Inner)`
  max-width: 800px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;

  ${theme.breakpoints.down("sm")} {
    flex-direction: column;
    text-align: center;
  }
`;

const PhotoWrapper = styled.div`
  position: relative;
  width: 280px;
  height: 280px;
  flex-shrink: 0;
  overflow: hidden;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.35);
  border-radius: 50%;
  opacity: 0.9;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: grayscale(10%);
  }
`;

const TextBlock = styled.div`
  flex: 1;

  p {
    line-height: 1.5rem;
  }
`;

const BadgesRow = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  justify-content: space-around;
  ${theme.breakpoints.down("sm")} {
    flex-direction: column;
    align-items: center;
  }
`;

const Badge = styled.div`
  width: 9.5rem;
  padding: 0.5rem;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  svg {
    font-size: 2.5rem;
    color: var(--my-color1);
    /* animation: spin 6s linear infinite; */
  }
  h4 {
    margin: 0;
    font-size: 1.2rem;
    color: white;
    margin-top: 0.5rem;
  }
  p {
    margin: 0;
    font-size: 0.8rem;
    color: white;
    text-align: center;
    margin-top: -0.25rem;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const AboutSection = () => {
  return (
    <Section id="about">
      <AnimateOnScroll type="fade">
        <Container>
          <PhotoWrapper>
            <img src={portrait} alt="Founder portrait" />
          </PhotoWrapper>
          <TextBlock>
            <HighlightTitle
              text="Qui suis-je ?"
              highlightWord="Qui"
              bg="white"
              rotateText={false}
              mainTextColor="white"
              textColor="var(--my-color3)"
            />
            <SubtitleSection
              style={{
                fontStyle: "italic",
                marginTop: "0.6rem",
                color: "var(--my-color5)",
              }}
            >
              “J’ai toujours pensé qu’un produit digital devait d’abord créer la
              confiance avant de vendre.”
            </SubtitleSection>

            <SubtitleSection
              style={{
                marginTop: "1rem",
                color: "white",
              }}
            >
              Ingénieur passionné, j’accompagne les entreprises vers la
              conversion digitale.
            </SubtitleSection>

            <BadgesRow>
              <Badge>
                <FiClock />
                <h4>8 ans</h4>
                <p>d’accompagnement</p>
              </Badge>
              <Badge>
                <FiTrendingUp />
                <h4>30+</h4>
                <p>projets livrés</p>
              </Badge>
              <Badge>
                <FiCpu />
                <h4>Tech & Biz</h4>
                <p>double compétence</p>
              </Badge>
            </BadgesRow>
          </TextBlock>
        </Container>
      </AnimateOnScroll>
    </Section>
  );
};

export default AboutSection;
